require('./scheduleSearchController');

'use strict';

angular.module('app.schedule.scheduleSearch.scheduleSearchDirective', [
  'app.schedule.scheduleSearch.scheduleSearchController'
])
    .directive('scheduleSearch', [
      function () {
        return {
          restrict: 'E',
          templateUrl: 'components/schedule/scheduleSearch/scheduleSearchView.html',
          controller: 'app.schedule.scheduleSearch.scheduleSearchController',
          scope: {
            hideDateSelector: '<?',
            hideFavoritesSelector: '<?',
            hideTerm: '<?',
            showTermResults: '=?',
            onSelected: '=?',
            showInstructions: '<?',
            termListTitle: '<?',
            alwaysOpen: '<?',
            name: '<?',
            isFavouritesManager: '<?'
          },
          link: function (scope, elm) {
            elm.addClass('schedule-search-directive');
          }
        };
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleSearch/scheduleSearchDirective.js